<template>
  <div :class="$style.container">
    <div :class="[$pgCTStyle.headerContainer, $style.headerContainer]">
      <div v-if="props.textTitle" :class="[$pgCTStyle.title, $style.title]">
        {{ props.textTitle }}
      </div>
      <div v-if="!props.textTitle" :class="[$pgCTStyle.title, $style.title]">
        {{ $t(disciplineOptions.find((option) => option.selectionValue === discipline)?.label || "unknown") }}{{ props.codeLanguage ? " - " + props.codeLanguage : "" }}
      </div>
      <div :class="$style.actionsContainer">
        <div title="View text details" :class="$pgCTStyle.actionIconContainer" @click="openInfoModal">
          <img :class="$pgCTStyle.actionIcon" :src="infoIcon" alt="info" />
        </div>
        <div
          title="Close this box"
          :class="[$pgCTStyle.actionIconContainer, $style.closeContainer]"
          @click="props.closeEnlargedTextsBox"
        >
          <img :class="$pgCTStyle.actionIcon" :src="closeIcon" alt="close" />
        </div>
      </div>
    </div>
    <div :class="$style.bodyContainer">
      <div v-for="(text, index) in props.texts" :key="index" :class="$style.textContainer">
        <div :class="[$style.textLabel, props.realTextId && props.realTextId == text.id ? $style.realTextLabel : '']">
          {{ $t('text') }} {{ text.label }}
        </div>
        <textarea v-model="text.content" :class="$style.textContent"></textarea>
        <!-- <div :class="$style.textContent">{{ text.content }}</div> -->
        <!-- <div :class="$style.textContentContainer"></div> -->
      </div>
    </div>

    <!-- Modal -->
    <div v-if="showInfoModal" :class="$utilModalStyle.modalOverlay" @click="closeModal">
      <div :class="$utilModalStyle.modalContent" @click.stop>
        <h3 :class="$utilModalStyle.modalTitle">{{ $t("game-details") }}</h3>
        <div :class="$utilModalStyle.modalBody">
          <p :class="$style.modelTextItem" v-if="props.discipline">
            <strong>{{ $t("discipline") }}:</strong>
            {{ $t(disciplineOptions.find((option) => option.selectionValue === discipline)?.label || "unknown") }}
          </p>
          <p :class="$style.modelTextItem" v-if="props.codeLanguage">
            <strong>{{ $t('code-language') }}:</strong> {{ props.codeLanguage }}
          </p>
          <p :class="$style.modelTextItem" v-if="props.textTitle"><strong>{{ $t('title') }}:</strong> {{ props.textTitle }}</p>
        </div>
        <div :class="$utilModalStyle.modalActions">
          <button :class="$utilModalStyle.primaryAction" @click="closeInfoModal">{{ $t('close') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import styles from "@/css/EnlargedGameTextsBox.module.css";
import playGameComponentsTemplateStyles from "@/css/PlayGameComponentsTemplate.module.css";
import { disciplineOptions } from "@/utils/data";
import utilModalStyles from "@/css/UtilModal.module.css";
import InfoIcon from "@/assets/icons/info.svg";
import CloseIcon from "@/assets/icons/close-red.svg";

const $style = styles;
const $pgCTStyle = playGameComponentsTemplateStyles;
const $utilModalStyle = utilModalStyles;
const infoIcon = InfoIcon;
const closeIcon = CloseIcon;

const showInfoModal = ref(false);

// eslint-disable-next-line
const props = defineProps({
  texts: {
    type: Array,
    required: true,
    default: () => [],
  },
  discipline: {
    type: String,
    required: false,
  },
  codeLanguage: {
    type: String,
    required: false,
  },
  textTitle: {
    type: String,
    required: false,
  },
  realTextId: {
    type: Number,
    required: false,
  },
  realTextLabel: {
    type: String,
    required: false,
  },
  closeEnlargedTextsBox: {
    type: Function,
    required: true,
  },
});

function openInfoModal() {
  showInfoModal.value = true;
}

function closeInfoModal() {
  showInfoModal.value = false;
}
</script>

<style scoped></style>
